module.exports = __webpack_public_path__ + "media/images/brands/lov_it-e130733884c8a926851b402bf2b421b3.png";